import React from "react";
import { Row, Col, Form, Input, Select, Checkbox, Radio } from "antd";

const MarketingSKUForm = ({
  offerSKU,
  setOfferSKU,
  skuId,
  brands,
  handleBrandChange,
  addNewOrSelect,
  setAddNewOrSelect
}) => {
  return (
    <Row gutter={16}>
      <Col span={8}>
        <Form.Item label="Brand">
          <Select
            options={brands}
            value={offerSKU?.brand}
            onChange={handleBrandChange}
          />
        </Form.Item>
      </Col>
      <Col span={5}>
        <Form.Item label="Marketing SKU">
          <Input
            value={offerSKU.skuCode}
            disabled={!!skuId}
            onChange={(e) => {
              setOfferSKU({
                ...offerSKU,
                skuCode: e.target.value?.toUpperCase(),
              });
            }}
          />
        </Form.Item>
      </Col>
      <Col span={5}>
        <Form.Item label="Is Bundle SKU?">
          <Checkbox
            disabled={skuId}
            checked={offerSKU.isBundleSKU}
            onChange={(e) => {
              setOfferSKU({
                ...offerSKU,
                isBundleSKU: e.target.checked,
              });
            }}
          />
        </Form.Item>
      </Col>
      {offerSKU.isBundleSKU && (
        <Col span={12}>
          <Form.Item label="Select Option" hidden={skuId}>
            <Radio.Group
              onChange={(e) => setAddNewOrSelect(e.target.value)}
              value={addNewOrSelect}
            >
              <Radio value={1}>
                <span style={{ color: "black" }}>
                  New Marketing Dependent SKU{" "}
                </span>
              </Radio>
              <Radio value={2}>
                <span style={{ color: "black" }}>
                  Select From Existing Marketing Dependent SKU
                </span>
              </Radio>
            </Radio.Group>
          </Form.Item>
        </Col>
      )}
    </Row>
  );
};

export default MarketingSKUForm;
